import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"];
var __jsx = React.createElement;
import { DownOutlined, EnvironmentOutlined, FacebookOutlined, InstagramOutlined, LinkedinOutlined, MailOutlined, TabletOutlined, TwitterOutlined, WhatsAppOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import DixuButton from "../DixuButton/DixuButton";
import DixuContainer from "../DixuContainer/DixuContainer";
import DixuDescriptionList from "../DixuDescriptionList/DixuDescriptionList";
import DixuDropdown from "../DixuDropdown/DixuDropdown";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuLink from "../DixuLink/DixuLink";
import DixuMenu from "../DixuMenu/DixuMenu";
import DixuText from "../DixuText/DixuText";
import DixuLogo from "../../public/icons/dixu.svg";
import React from 'react';
import { DIXU_CONTACT_INFO } from "../../utils/DixuConstants";
import { toRem } from "../../utils/Utils";
const DixuMainFooter = _ref => {
  let {
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-main-footer', className);
  const socialItems = [{
    icon: /*#__PURE__*/React.createElement(WhatsAppOutlined, null),
    href: DIXU_CONTACT_INFO.whatsapp,
    label: 'WhatsApp'
  }, {
    icon: /*#__PURE__*/React.createElement(TwitterOutlined, null),
    href: DIXU_CONTACT_INFO.twitter,
    label: 'Twitter'
  }, {
    icon: /*#__PURE__*/React.createElement(FacebookOutlined, null),
    href: DIXU_CONTACT_INFO.facebook,
    label: 'Facebook'
  }, {
    icon: /*#__PURE__*/React.createElement(InstagramOutlined, null),
    href: DIXU_CONTACT_INFO.instagram,
    label: 'Instagram'
  }, {
    icon: /*#__PURE__*/React.createElement(LinkedinOutlined, null),
    href: DIXU_CONTACT_INFO.linkedin,
    label: 'LinkedIn'
  }].filter(item => {
    const {
      href
    } = item;
    return !!href;
  });
  const navItems = [[{
    href: '/myytavat-asunnot',
    label: 'Asunnot'
  }, {
    href: '/myy-asuntosi',
    label: 'Myy asuntosi',
    subitems: [{
      href: '/myy-asuntosi',
      label: 'Näin myyt asuntosi'
    }, {
      href: '/hinnasto',
      label: 'Hinnasto'
    }, {
      href: '/asiakaskokemukset',
      label: 'Asiakaskokemuksia'
    }, {
      href: '/yhteistyokumppanit',
      label: 'Yhteistyökumppanit'
    }]
  }, {
    href: '/valittajalle',
    label: 'Välittäjälle'
  }], [{
    href: '/meista',
    label: 'Yritys',
    subitems: [{
      href: '/meista',
      label: 'Yritys'
    }, {
      href: '/ota-yhteytta',
      label: 'Ota yhteyttä'
    }, {
      href: '/faq',
      label: 'UKK'
    }, {
      href: '/yhteistyokumppanit',
      label: 'Yhteistyökumppanit'
    }]
  }]];
  const companyInfoItems = [{
    icon: /*#__PURE__*/React.createElement(EnvironmentOutlined, null),
    name: 'Osoite',
    value: `${DIXU_CONTACT_INFO.address}, ${DIXU_CONTACT_INFO.postalCode} ${DIXU_CONTACT_INFO.city}`,
    iconProps: {
      color: '2-1',
      font: '5'
    },
    nameProps: {
      className: 'vhidden'
    },
    valueProps: {
      color: '2-1',
      hyphens: false
    }
  }, {
    icon: /*#__PURE__*/React.createElement(MailOutlined, null),
    name: 'Sähköposti',
    value: /*#__PURE__*/React.createElement(DixuLink, {
      href: `mailto:${DIXU_CONTACT_INFO.email}`,
      color: "2-1"
    }, DIXU_CONTACT_INFO.email),
    iconProps: {
      color: '2-1',
      font: '5'
    },
    nameProps: {
      className: 'vhidden'
    }
  }, {
    icon: /*#__PURE__*/React.createElement(TabletOutlined, null),
    name: 'Puhelinnumero',
    value: /*#__PURE__*/React.createElement(DixuLink, {
      href: `tel:${DIXU_CONTACT_INFO.tel}`,
      color: "2-1"
    }, DIXU_CONTACT_INFO.tel),
    iconProps: {
      color: '2-1',
      font: '5'
    },
    nameProps: {
      className: 'vhidden'
    }
  }];
  const mappedSocialItems = socialItems.map(link => {
    const {
      icon,
      href,
      label
    } = link;
    return /*#__PURE__*/React.createElement(DixuButton, {
      key: label,
      icon: icon,
      href: href,
      "aria-label": label,
      block: false,
      type: "outline",
      modifierType: "circle",
      font: "3",
      shadow: "1",
      noBorder: true,
      external: true,
      className: "dixu-main-footer__social-link"
    });
  });
  const mappedNavItems = navItems.filter(e => e.length > 0).map((itemGroup, index) => {
    const mappedGroup = itemGroup.map(item => {
      const {
        href,
        label,
        external,
        noRouterLink,
        subitems
      } = item;
      const hasSubitems = !!subitems?.length;
      const link = /*#__PURE__*/React.createElement(DixuLink, {
        href: hasSubitems ? '' : href,
        color: "2-1",
        font: "3",
        weight: "bold",
        external: external,
        noRouterLink: noRouterLink,
        className: "dixu-main-footer__nav-link",
        onClick: event => {
          if (hasSubitems) {
            event.preventDefault();
          }
        }
      }, label, hasSubitems && /*#__PURE__*/React.createElement(DixuText, {
        font: "1"
      }, /*#__PURE__*/React.createElement(DownOutlined, {
        style: {
          position: 'relative',
          width: 0,
          left: toRem(4)
        }
      })));
      const navItem = (() => {
        if (hasSubitems) {
          const menuItems = subitems.map(subitem => {
            const {
              href: subitemHref,
              label: subitemLabel,
              noRouterLink: subitemNoRouterLink,
              external: subitemExternal
            } = subitem;
            return /*#__PURE__*/React.createElement(DixuMenu.Item, {
              key: subitemLabel
            }, /*#__PURE__*/React.createElement(DixuLink, {
              href: subitemHref,
              font: "2",
              color: "2-8",
              noRouterLink: subitemNoRouterLink,
              external: subitemExternal
            }, subitemLabel));
          });
          const menu = /*#__PURE__*/React.createElement(DixuMenu, {
            forceSubMenuRender: true
          }, menuItems);
          return /*#__PURE__*/React.createElement(DixuDropdown, {
            overlay: menu
          }, /*#__PURE__*/React.createElement("div", null, link));
        }
        return link;
      })();
      return /*#__PURE__*/React.createElement("li", {
        key: label,
        className: "dixu-main-footer__nav-item"
      }, navItem);
    });
    return /*#__PURE__*/React.createElement("ul", {
      key: index.toString(36),
      className: "dixu-main-footer__nav-item-group"
    }, mappedGroup);
  });
  const legalInfo = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "m-b-16"
  }, /*#__PURE__*/React.createElement(DixuLink, {
    href: "/pdfs/Asiakas-_ja_markkinointirekisterin_tietosuojaseloste.pdf",
    color: "2-1",
    weight: "medium",
    external: true
  }, "Tietosuojaseloste"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(DixuLink, {
    href: "/pdfs/K\xE4ytt\xF6ehdot.pdf",
    color: "2-1",
    weight: "medium",
    external: true
  }, "K\xE4ytt\xF6ehdot")), /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: [16, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuImage, {
    src: "/images/code_from_finland_white.png",
    width: "64",
    height: "64",
    fit: "contain"
  })), /*#__PURE__*/React.createElement(DixuCol, null, "\xA9 DIXU ", new Date().getFullYear())));
  const legalInfoMobile = /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-1",
    align: "center",
    weight: "medium"
  }, legalInfo);
  const legalInfoDesktop = /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-1",
    align: "center",
    weight: "medium"
  }, legalInfo);
  return /*#__PURE__*/React.createElement("footer", _extends({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(DixuContainer, {
    verticalPadding: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "dixu-main-footer__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dixu-main-footer__social-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dixu-main-footer__logo-wrapper"
  }, /*#__PURE__*/React.createElement(DixuLink, {
    href: "/",
    "aria-label": "Dixu"
  }, /*#__PURE__*/React.createElement(DixuLogo, null))), /*#__PURE__*/React.createElement(DixuButton.Group, {
    justify: "center",
    spacing: "lg",
    className: "dixu-main-footer__social-links"
  }, mappedSocialItems), /*#__PURE__*/React.createElement("div", {
    className: "dixu-main-footer__legal-info dixu-main-footer__legal-info--desktop"
  }, legalInfoDesktop)), /*#__PURE__*/React.createElement("nav", {
    className: "dixu-main-footer__nav-links"
  }, mappedNavItems), /*#__PURE__*/React.createElement(DixuDescriptionList, {
    vertical: true,
    items: companyInfoItems,
    className: "dixu-main-footer__company-info",
    valueProps: {
      weight: 'medium'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "dixu-main-footer__legal-info"
  }, legalInfoMobile))));
};
DixuMainFooter.defaultProps = {};
export default DixuMainFooter;